import React from 'react';

const Modal = ({ isOpen, handleClose, children, title }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800/70 overflow-y-auto p-2 sm:p-4"
      id="my-modal"
    >
      {/* Outer container with rounded corners and hidden overflow to preserve radius */}
      <div className="relative mx-auto w-full max-w-4xl lg:max-w-5xl border-0 shadow-2xl rounded-3xl bg-white z-50 transition-all duration-300 animate-fadeIn overflow-hidden my-auto p-5 pt-14 sm:p-8 sm:pt-16 lg:p-10 lg:pt-16">
        {/* Close button */}
        <button 
          onClick={handleClose} 
          className="absolute top-3 right-3 bg-pink-100 text-pink-700 font-bold rounded-full p-2 w-9 h-9 flex items-center justify-center hover:bg-pink-200 focus:outline-none focus:ring-2 focus:ring-pink-300 transition-colors z-10"
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
        </button>

        {/* Scrollable content wrapper */}
        <div className="overflow-y-auto max-h-[min(86dvh,56rem)] mt-1 rounded-b-3xl pr-1 custom-scroll">
          <div className="px-1 py-1 sm:px-2 sm:py-2">
            {children}
          </div>
        </div>
      </div>

      {/* Custom scrollbar styling */}
      <style>{`
        .custom-scroll::-webkit-scrollbar {
          width: 8px;
        }
        .custom-scroll::-webkit-scrollbar-track {
          background: transparent;
        }
        .custom-scroll::-webkit-scrollbar-thumb {
          background-color: rgba(148, 163, 184, 0.4);
          border-radius: 10px;
        }
        .custom-scroll::-webkit-scrollbar-thumb:hover {
          background-color: rgba(148, 163, 184, 0.6);
        }
      `}</style>
    </div>
  );
};

export default Modal;
